export default "__VITE_ASSET__c31cb582__"